// extracted by mini-css-extract-plugin
export var active = "_3g-7";
export var container = "_3g-0";
export var evenWidth = "_3g-4";
export var large = "_3g-5";
export var outlet = "_3g-8";
export var slide = "_3g-2";
export var small = "_3g-6";
export var tab = "_3g-3";
export var tabs = "_3g-1";